<template>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <div class="onboarding">
                <p>
                    Progress
                </p>
                <div class="progress">
                    <div class="progress-bar" 
                        role="progressbar" 
                        :style="'width: ' + profilePercentage + '%'" 
                        :aria-valuenow="profilePercentage" 
                        aria-valuemin="0" 
                        aria-valuemax="100">
                        {{ profilePercentage }}%
                    </div>
                </div>

                <div class="onboard-area">

                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <section class="component component-text-full-inline mb-0">
                                        <div class="row">
                                            <div class="col">
                        
                                                <template v-if="!hasStarted && step != 'complete'">
                                                    <welcome-component />
                                                </template>
                                                
                                                <template v-else>

                                                    <template v-if="step == 'metaProfileInfo'">
                                                        <meta-profile-info-component :is-onboarding="true" />
                                                    </template>
                                                    <template v-if="step == 'genres'">
                                                        <h2>Select your favourite genres</h2>
                                                        <genres-component :is-onboarding="true" />
                                                    </template>
                                                    <template v-if="step == 'profileImg'">
                                                        <h2>Profile Picture</h2>
                                                        <profile-photo-onboarding-component />
                                                    </template>
                                                    <template v-if="step == 'username'">
                                                        <h2>Username</h2>
                                                        <p class="mb-2">
                                                            Choose a unique username.
                                                        </p>
                                                        <username-selection-onboarding-component />
                                                    </template>
                                                    <template v-if="step == 'bio'">
                                                        <h2>Bio</h2>
                                                        <p class="mb-2">
                                                            Add a short bio to your profile.  Tell us a little about yourself and what
                                                            you're looking to achieve.
                                                        </p>
                                                        <bio-onboarding-component />
                                                    </template>
                                                    <template v-if="step == 'complete'">
                                                        <h2>Thanks!</h2>
                                                        <p>
                                                            You're all done and your profile is now complete.
                                                        </p>
                                                        <p>
                                                            Why not take a look at our <a href="/courses">courses</a>
                                                            or visit your <a :href="profileUrl">profile</a>.
                                                        </p>
                                                    </template>

                                                </template>

                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            percentageComplete: {
                type: Number,
                default: null
            },
        },

        data() {
            let profileUrl = window.virtuoso.user.profileUrl;
            return {
                profilePercentage: 0,
                hasStarted: false,
                step: '',
                profileUrl: profileUrl,
            }
        },

        mounted() {
            this.profilePercentage = this.percentageComplete ?? 0;

            this.getCurrentStep();
            
            // When payment methods have been updated refresh that section
            Bus.$on("stepComplete", (d) => {
                if(d.step == 'welcome') {
                    this.hasStarted = true;
                }

                if(d.step == 'metaProfileInfo') {
                    this.step = 'genres';
                    this.profilePercentage = d.percentageComplete;
                }

                if(d.step == 'genres') {
                    this.step = 'profileImg';
                    this.profilePercentage = d.percentageComplete;
                }

                if(d.step == 'profileImg') {
                    this.step = 'username';
                    this.profilePercentage = d.percentageComplete;
                }

                if(d.step == 'username') {
                    this.step = 'bio';
                    this.profilePercentage = d.percentageComplete;
                }

                if(d.step == 'bio') {
                    this.step = 'complete';
                    this.profilePercentage = d.percentageComplete;
                    
                    // Get the user's profile url, we can't rely on the one set in `window` because it may have been updated
                    this.getProfileUrl();
                    this.markOnboardingComplete();
                }
            });
        },

        methods: {
            // Get the current step.  It's different depending on how someone signed up
            getCurrentStep() {
                axios.get('/api/me/get-onboarding-step').then((response) => {
                    this.step = response.data.step;
                });
            },

            // Get the current profile url.
            getProfileUrl() {
                axios.get('/api/me/get-profile-url').then((response) => {
                    this.profileUrl = response.data.profileUrl;
                });
            },

            // Mark onboarding as completed
            markOnboardingComplete() {
                axios.post('/api/me/complete-onboarding');
            },
        }
    }
</script>